import { ApiReference } from "../../../../src/smooth-doc/components/ApiReference";
import { ApiReferences } from "../../../../src/smooth-doc/components/ApiReferences";
import sims from "../../../../pages/docs/images/sim-search/sim-search.svg";
import * as React from 'react';
export default {
  ApiReference,
  ApiReferences,
  sims,
  React
};